import script from "./Auth.vue?vue&type=script&lang=ts&setup=true"
export * from "./Auth.vue?vue&type=script&lang=ts&setup=true"

import "./Auth.vue?vue&type=style&index=0&id=07b23060&lang=sass"

const __exports__ = script;

export default __exports__